import { ConstrainMode, IColumn, mergeStyleSets } from '@fluentui/react';
import { IPDetailsList, IPIcon, IPLink, IPScrollablePane, IPSpinner, IPStack, IPText } from 'baseComponents';
import { IPDetailsListLayoutMode } from 'baseComponents/DetailsList/IPDetailsList';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPSpinnerSize } from 'baseComponents/Spinner/IPSpinner';
import { IPSelectionMode, IPSelection } from 'baseComponents/Utils/Selection';
import { globalStackTokensGapSmall } from 'globalStyles';
import { useTranslation } from 'react-i18next';
import { IList } from '../../services/Graph/SharepointInterfaces';

interface IMyListsProps {
  lists: IList[];
  onSelect: (item: IList) => void;
  isListLoading: boolean;
  onSelectListItemMode?: (item: IList) => void;
}

const MyLists = (props: IMyListsProps) => {
  const { t } = useTranslation(['sharepoint']);

  const columns: IColumn[] = [
    {
      key: 'icon',
      minWidth: 15,
      maxWidth: 15,
      onRender: () => {
        return (
          <IPStack verticalAlign="center">
            <IPIcon iconName={'BulletedList2'} className={classes.icon} />
          </IPStack>
        );
      },
      name: '',
    },
    {
      key: 'list',
      minWidth: 200,
      name: '',
      onRender: (item?: IList, index?: number | undefined, column?: IColumn | undefined) => {
        if (!item) return;
        if (props.onSelectListItemMode)
          return (
            <IPText>
              <IPLink
                underline
                onClick={() => {
                  if (props.onSelectListItemMode) props.onSelectListItemMode(item);
                }}
              >
                {item.name}
              </IPLink>
            </IPText>
          );

        return <IPText>{item.name}</IPText>;
      },
    },
  ];

  const classes = mergeStyleSets({
    icon: {
      fontSize: '16px',
    },
  });

  if (props.isListLoading) {
    return (
      <IPStack verticalFill verticalAlign="center">
        <IPSpinner size={IPSpinnerSize.large} />
      </IPStack>
    );
  }

  const selection = new IPSelection({
    onSelectionChanged: () => {
      const item = selection.getSelection()[0] as IList;
      props.onSelect(item);
    },
  });

  if (props.lists.length === 0) {
    return (
      <IPStack verticalFill horizontalAlign="center" verticalAlign="center">
        <IPText>{t('sharepoint:SharepointPicker.NoData')}</IPText>
      </IPStack>
    );
  }

  return (
    <IPStack grow styles={{ root: { position: 'relative' } }} verticalFill>
      <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>
        <IPStack.Item tokens={globalStackTokensGapSmall} grow verticalFill>
          <IPDetailsList
            selection={selection}
            columns={columns}
            items={props.lists}
            layoutMode={IPDetailsListLayoutMode.justified}
            constrainMode={ConstrainMode.unconstrained}
            isHeaderVisible={false}
            selectionMode={props.onSelectListItemMode ? IPSelectionMode.none : IPSelectionMode.single}
          />
        </IPStack.Item>
      </IPScrollablePane>
    </IPStack>
  );
};

export default MyLists;
